import React, { useEffect, useRef } from "react";
import Header from "../Home/Header";
import Navbar from "../commons/Navbar";
import HeaderBox from "../Home/HeaderBox";
import styles from "./Thanks.module.css";

const Thanks = ({
  navigationId,
  setNavigationId,
  setProductData,
  setParentProduct,
}) => {
  const windowSizeResolution = useRef(null, "windowSizeResolution");
  useEffect(() => {
    window.innerWidth === 1536
      ? (windowSizeResolution.current.id = "rest-banner")
      : (windowSizeResolution.current.id = "rest-banner");
  }, []);
  const alphabetArray = "abcdefghijklmnopqrstuvwxyz".split("");
  // const [navId, setNavId] = useState(1);
  // const handleCallback = (childdata) => {
  //   setNavigationId(childdata);
  // };
  // console.log(Arr[0].megaMenu[0].subMenu);

  return (
    <>
      <div className={styles.productBanner} ref={windowSizeResolution}>
        <HeaderBox id={navigationId} />
        <Header />
        <Navbar
          setNavigationId={setNavigationId}
          setParentProduct={setParentProduct}
        />
        <div className={styles.DictionaryMainContainer}>
          <h1>Thanks for connecting with us will get in touch with shortly</h1>

          <div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Thanks;
